export default "__VITE_ASSET__DvK6WIna__"